export default __webpack_public_path__ + "static/media/heart.90281bb5.png";